import { useEffect, useRef } from 'react'
import { addGTMEvent } from 'api/googleTagManager'
import BrowserInteractionTime from 'browser-interaction-time'

interface UserTimingEvent {
  eventCategory: string
  label: string
  value: number
  variable: string
}

/**
 * Used to track performance events.
 * Ex.: Time to load JS, time for a component to appear.
 */
export function reportUserTimingEvent(event: UserTimingEvent) {
  addGTMEvent({
    event: 'ua-timing-event',
    eventVariable: event.variable,
    eventCategory: event.eventCategory,
    eventValue: event.value,
    eventLabel: event.label,
  })
}

export enum IdleTimeSource {
  FlashHotel = 'flash_hotel',
  BundleAndSave = 'bundle_and_save',
  AlwaysOn = 'always_on',
  HotelSearchPage = 'hotel_search_page',
  ExpiredDeals = 'expired_deals',
  DestionationLp = 'destination_lp'
}

const DEFAULT_THRESHOLD = 3000

function useIdleTimeReporter(label: IdleTimeSource, threshold: number = DEFAULT_THRESHOLD) {
  const activeRef = useRef(false)
  const lastInactiveTimeRef = useRef(0)

  useEffect(() => {
    let timer: BrowserInteractionTime | null
    try {
      timer = new BrowserInteractionTime({
        idleTimeoutMs: threshold,
        stopTimerOnTabchange: false,
        browserTabActiveCallbacks: [],
        browserTabInactiveCallbacks: [],
        idleCallbacks: [
          () => {
            if (activeRef.current) {
              lastInactiveTimeRef.current = Date.now()
              activeRef.current = false
            }
          },
        ],
        activeCallbacks: [
          () => {
            if (!activeRef.current) {
              activeRef.current = true
              if (lastInactiveTimeRef.current > 0) {
                const timeIdle = Date.now() - lastInactiveTimeRef.current + threshold
                reportUserTimingEvent({
                  eventCategory: 'lere',
                  variable: 'timeIdle',
                  value: timeIdle,
                  label,
                })
                lastInactiveTimeRef.current = 0
              }
            }
          },
        ],
      })
      timer.startTimer()
    } catch {

    }

    return () => {
      timer && timer.destroy()
      timer = null
    }
  }, [threshold, label])
}

export default useIdleTimeReporter
